import script from "./loginIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./loginIndex.vue?vue&type=script&setup=true&lang=js"

import "./loginIndex.vue?vue&type=style&index=0&id=195bfefb&lang=css"

const __exports__ = script;

export default __exports__